import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class GoogleMapsLoaderService {
  private apiKey = environment.GOOGLE_MAPS_API_KEY;
  private loading: Promise<void> | null = null;

  async load(): Promise<void> {
    if (this.loading) return this.loading;

    this.loading = new Promise<void>((resolve, reject) => {
      if (document.getElementById('google-maps-script')) {
        resolve();
        return;
      }

      const script = document.createElement('script');
      script.id = 'google-maps-script';
      script.src = `https://maps.googleapis.com/maps/api/js?key=${this.apiKey}`;
      script.async = true;
      script.defer = true;

      script.onload = () => resolve();
      script.onerror = () => reject('Google Maps failed to load');

      document.body.appendChild(script);
    });

    return this.loading;
  }
}
